var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12,0C5.37,0,0,5.37,0,12s5.37,12,12,12,12-5.37,12-12S18.63,0,12,0Zm0,22.42c-5.74,0-10.42-4.67-10.42-10.42S6.26,1.58,12,1.58s10.42,4.67,10.42,10.42-4.67,10.42-10.42,10.42Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13.25,8.37h-1.52v2.99h1.28c1.04,0,1.74-.57,1.74-1.49s-.67-1.51-1.5-1.51Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12,3C7.03,3,3,7.03,3,12s4.03,9,9,9,9-4.03,9-9S16.97,3,12,3Zm1.37,9.68h-1.64v2.35c0,.37,.21,.6,.58,.6h1v1.31h-2.41v1.81h-1.15v-1.81h-2.31v-1.31h.91c.37,0,.58-.22,.58-.6v-6.07c0-.37-.21-.6-.58-.6h-.92v-1.31h2.32v-1.95h1.15v1.95h2.77c2.44,0,3.89,.76,3.89,2.8s-1.45,2.82-4.19,2.82Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.72cebef1d51d5a08579f17d3d73012ce.svg";
export { ForwardRef as ReactComponent };